import { createSlice } from "@reduxjs/toolkit";

const bellNotificationSlice = createSlice({
  name: "bellNotification",
  initialState: {
    bellNotificationData: {
      unreadCount: 0,
      data: [],
    },
  },
  reducers: {
    setBellNotificationData: (state, action) => {
      state.bellNotificationData.data = action.payload.data;
      state.bellNotificationData.unreadCount = action.payload.unreadCount;
    },
  },
});

export const { setBellNotificationData } = bellNotificationSlice.actions;

export const selectBellNotificationData = (state) =>
  state.bellNotification.bellNotificationData.data;

export const selectBellNotificationCount = (state) =>
  state.bellNotification.bellNotificationData.unreadCount;

export default bellNotificationSlice.reducer;
